import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
};

export const wrapper: SxStyle = {
  display: 'flex',
  alignItems: 'flex-start',
  flexDirection: 'row',
  gap: (p) => p.spacing(1.5),
  padding: (p) => p.spacing(3),

  ':hover': {
    background: (p) => p.palette.grey[100],
  },
};

export const content: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: (p) => p.spacing(1),
  width: '100%',
  overflow: 'hidden',
};

export const header: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  justifyContent: 'space-between',
};

export const body: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  padding: (p) => p.spacing(0.5, 0, 0.5, 1.25),
  gap: (p) => p.spacing(1.25),
  borderRadius: (p) => p.spacing(0.5),
  borderLeftWidth: (p) => p.spacing(0.5),
  borderLeftStyle: 'solid',
  borderLeftColor: (p) => p.palette.grey[300],
};

export const iconStatusWrapper: SxStyle = {
  borderRadius: (p) => p.spacing(1),
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.grey[300],
  padding: (p) => p.spacing(0.75),
  position: 'relative',
};

export const icon: SxStyle = {
  color: (p) => p.palette.grey[600],
};

export const titleWrapper: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: (p) => p.spacing(0.5),
};

export const title: SxStyle = {
  fontSize: (p) => p.typography.body3.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
  color: (p) => p.palette.grey[800],
};

export const message: SxStyle = {
  fontSize: (p) => p.typography.body3.fontSize,
  color: (p) => p.palette.grey[600],
  whiteSpace: 'pre-wrap',
};

export const closeIcon: SxStyle = {
  color: (p) => p.palette.grey[500],
  cursor: 'pointer',
};

export const dateWrapper: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: (p) => p.spacing(0.5),
};

export const date: SxStyle = {
  color: (p) => p.palette.grey[500],
  fontSize: (p) => p.typography.caption,
};

export const divider: SxStyle = {
  color: (p) => p.palette.grey[300],
};
